import IndexTableRow from '../index-table/IndexTableRow';
import IndexTableRowRenderer from '../index-table/IndexTableRowRenderer';
import buildResourcePath from '@lib/buildResourcePath';
import Assets from '../../Assets';
import Modal from '../common/Modal';
import Button from '../common/Button';
import Loader from '../common/Loader';
import { Message } from 'src/application/Contracts';

export default class MessageIndexTableRow extends IndexTableRow {
    state = {
        respondModalVisible: false,
        respondText: '',
        isSending: false
    }

    constructor(props) {
        super(props)
    }

    loadRowRenderer() {
        this.rowRenderer = new IndexTableRowRenderer(this.props, this);
    }

    renderReadColumn = (column, value) => {

        if (value === true || value === "True") {
            return (<td></td>);
        }
        return <td>
            <div className="new-message-tag">New</div>
        </td>;
    }

    renderProjectNumberColumn = (column, value) => {
        return <td><a href={buildResourcePath(`/${this.props.row.isTws ? "TWS":""}Project/Edit/${this.props.row.projectId}`)}>{value}</a></td>
    }

    renderrespondButtonAction = (button, index, editAPIService) => {
        if (this.props.row.canRespond) {
            return (
                <td>
                    <img onClick={() => this.setState({respondModalVisible: true})} src={Assets.eventHistory}></img>
                    {this.respondModalRender(editAPIService)}
                </td>
            );
        }

        return <td></td>
    }

    respondModalRender = (editAPIService) => {
        return (
            <Modal isOpen={this.state.respondModalVisible} onClose={() => this.setState({respondModalVisible: false})}>
                <Modal.Header>{__('Respond to')} {this.props.row.projectName}</Modal.Header>
                <Modal.Body>
                    {
                        this.state.isSending ? (
                                <div className="loading-overlay" style={{backgroundColor: '#ffffff'}}>
                                    <div className="ball-loader visible">
                                        <div className="ball-loader-ball1"></div>
                                        <div className="ball-loader-ball2"></div>
                                        <div className="ball-loader-ball3"></div>
                                    </div>
                                </div>
                            ) :
                            (
                                <input placeholder={__('Start writing a message')} type="text"
                                       value={this.state.respondText}
                                       onChange={(e) => this.setState({respondText: e.target.value})}></input>)
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => {
                        this.setState({
                            isSending: true
                        }, () => {
                            this.sendRespond(editAPIService);
                        })
                    }}>{__('Send')}
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }

    sendRespond(editAPIService) {
        var api = editAPIService;
        var model = {
            content: this.state.respondText,
            projectId: this.props.row.projectId, 
            date: new Date(),
            applicationType: this.props.row.isTws ? Message.ApplicationType.TWS : Message.ApplicationType.WebSelect,
        };
        api.sendRespond(model).catch((e) => {
            this.setState({
                respondText: '',
                respondModalVisible: false
            });
        });
    }
}